<div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12 mb-lg-0 mb-3">
            <h4 class="font-weight-bold title_size20">Add Drug</h4>
            <div class="card-body p-0">
              <form [formGroup]="drugForm" (ngSubmit)="submitForm()">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="small white-space pb-1">Drug Name</label>
                      <input type="text" class="form-control" placeholder="Drug Name" formControlName="name"/>
                      <mat-error *ngIf="submitted && drugForm.get('name')!.errors?.required">
                        Drug Name is required
                      </mat-error>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label class="small white-space pb-1">DIN</label>
                      <input type="text" class="form-control" placeholder="DIN" formControlName="din"/>
                      <mat-error *ngIf="submitted && drugForm.get('din')!.errors?.required">
                        DIN is required
                      </mat-error>
                      <mat-error class="ml-3" *ngIf="drugForm.controls['din'].touched && drugForm.controls['din'].hasError('pattern')">
                      Please enter a positive number.
                    </mat-error>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label class="small white-space pb-1">Form</label>
                      <input type="text" class="form-control" placeholder="Form" formControlName="durg_from"/>
                      <mat-error *ngIf="submitted && drugForm.get('durg_from')!.errors?.required">
                        Form is required
                      </mat-error>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label class="small white-space pb-1">Strength</label>
                      <input type="text" class="form-control" placeholder="Strength" formControlName="strength"/>
                      <mat-error *ngIf="submitted && drugForm.get('strength')!.errors?.required">
                        Strength is required
                      </mat-error>
                    </div>
                  </div>
                </div>
  
                <div class="row">
                  <div class="col-12 d-flex justify-content-end">
                    <button class="custom-btn mt-3 mr-2" type="button" (click)="this.dialogRef.close()">
                      Cancel
                    </button>
                    <button class="custom-btn mt-3 ml-0" type="submit">
                      Submit
                    </button>
                 
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  